<template>
  <div ref="componentRef" class="stepper">
    <div class="minus-icon" :style="plusStyle" @click="handleMinus"></div>
    <div :style="numberStyle">{{ modelValue }}</div>
    <div class="plus-icon" :style="plusStyle" @click="handlePlus"></div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted, nextTick, computed } from 'vue'
import { info, defaultProps } from './config'
import useAppStore from '@/h5/stores/app'
import { computeRatioPx } from '@/packages/plugins/utils'

defineOptions({ name: info.name })
const props = defineProps(defaultProps)
const uuid = ref()
const appStore = useAppStore ? useAppStore() : null
const componentRef = ref()
const modelValue = ref(props.number)

const plusStyle = computed(() => {
  return {
    width: computeRatioPx(44),
    height: computeRatioPx(44)
  }
})

const numberStyle = computed(() => {
  return {
    minWidth: computeRatioPx(64),
    height: computeRatioPx(44),
    lineHeight: computeRatioPx(44),
    margin: `0 ${computeRatioPx(4)}`,
    textAlign: 'center'
  }
})

watch(
  () => props.number,
  (val) => {
    // 配置数据更新
    modelValue.value = val
  }
)

watch(
  () => modelValue.value,
  (val) => {
    // 配置数据更新
    appStore && appStore.setPageDataSource(uuid.value, { value: val })
  }
)

const handleMinus = () => {
  if (modelValue.value - props.min >= props.interval) {
    modelValue.value -= props.interval
  }
}

const handlePlus = () => {
  if (props.max - modelValue.value >= props.interval) {
    modelValue.value += props.interval
  }
}

const setIntersectionObserver = () => {
  if (componentRef.value) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // 当元素重新展示时，重新设置为默认值
          modelValue.value = props.number
          console.log('元素进入视图窗口', modelValue.value)
        }
      })
    })
    observer.observe(componentRef.value)
  }
}

onMounted(() => {
  nextTick(() => {
    if (componentRef.value) {
      uuid.value = componentRef.value.getAttribute('id') || ''
      appStore && appStore.setPageDataSource(uuid.value, { value: props.number })
      setIntersectionObserver()
    }
  })
})
</script>

<style scoped lang="scss">
.stepper {
  display: flex;
  justify-content: center;
  align-items: center;
  .plus-icon {
    width: 22px;
    height: 22px;
    background: #1989fa;
    color: #fff;
    position: relative;
    border-radius: 100%;
    box-sizing: border-box;
    border: 0;
    margin: 0;
    padding: 0;
  }
  .plus-icon:before {
    content: '';
    width: 50%;
    height: 1px;
    background-color: white;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .plus-icon:after {
    content: '';
    width: 1px;
    height: 50%;
    background-color: white;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .minus-icon {
    width: 22px;
    height: 22px;
    background: #fff;
    color: #1989fa;
    position: relative;
    border-radius: 100%;
    box-sizing: border-box;
    border: 1px solid #1989fa;
    margin: 0;
    padding: 0;
  }
  .minus-icon:before {
    content: '';
    width: 50%;
    height: 1px;
    background-color: #1989fa;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
